import { useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import axios from "axios";

const RegistroSocioModal = ({ show, handleClose }) => {
  const [rut, setRut] = useState("");
  const [nSocio, setNSocio] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [loading, setLoading] = useState(false);

  const validarRut = (valor) => {
    // Acepta números y k/K al final
    const rutRegex = /^[0-9]+[-]?[0-9kK]?$/;
    return rutRegex.test(valor);
  };

  const handleRegistro = async (e) => {
    e.preventDefault();
    setMensaje("");

    // Validar RUT antes de enviar
    if (!validarRut(rut)) {
      setMensaje("El RUT ingresado no es válido. Use solo números y la letra K o k si aplica.");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post("https://socios.kolpingchile.cl/backend/api/register/socios", {
        username: rut.toLowerCase(), // Aseguramos que la K quede en mayúscula
        n_socio: nSocio,
      });
      setRut("");
      setNSocio("");
      setMensaje("Socio registrado exitosamente.");
      window.alert("Socio registrado exitosamente.");
      handleClose();
    } catch (error) {
      setMensaje(error.response?.data?.message || "Error en el servidor.");
    } finally {
      setLoading(false);
    }
  };

  const handleRutChange = (e) => {
    // Convierte automáticamente la k en K
    const value = e.target.value.toUpperCase();
    setRut(value);
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Registro de Socio</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {mensaje && (
          <Alert variant={mensaje.includes("exitosamente") ? "success" : "danger"}>
            {mensaje}
          </Alert>
        )}
        <Form onSubmit={handleRegistro}>
          <Form.Group className="mb-3">
            <Form.Label>RUT</Form.Label>
            <Form.Control
              type="text"
              placeholder="Sin puntos ni guion (ej: 12345678K)"
              value={rut}
              onChange={handleRutChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Número de Socio</Form.Label>
            <Form.Control
              type="text"
              placeholder="Ej: 125"
              value={nSocio}
              onChange={(e) => setNSocio(e.target.value)}
              required
            />
          </Form.Group>
          <Button type="submit" disabled={loading} className="w-100">
            {loading ? "Verificando..." : "Registrar"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default RegistroSocioModal;
